/* Presentation only: use the existing theme slideshow API; never touch purchase state. */
if (!customElements.get('fiorpaw-pillow-views')) {
  class FiorpawPillowViews extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.gallery = this.closest('media-gallery');
      this.slideshow = this.gallery?.querySelector('slideshow-component');
      if (!this.slideshow) return;
      this.addEventListener('click', (event) => {
        const button = event.target.closest('button[data-pillow-media]');
        if (!button || !this.contains(button) || button.disabled) return;
        const index = Array.from(this.slideshow.querySelectorAll('slideshow-slide')).findIndex(slide =>
          slide.querySelector('[data-media-id]')?.dataset.mediaId === button.dataset.pillowMedia
        );
        if (index < 0) return;
        this.slideshow.select(index, event, {
          animate: !window.matchMedia('(prefers-reduced-motion: reduce)').matches
        });
        // Selecting the already-active native slide may not emit a slideshow event.
        this.updateSelection(button.dataset.pillowMedia);
      }, { signal });
      this.gallery.addEventListener('slideshow:select', (event) => {
        if (event.target !== this.slideshow) return;
        this.updateSelection(event.detail.slide?.querySelector('[data-media-id]')?.dataset.mediaId);
      }, { signal });
      customElements.whenDefined('slideshow-component').then(() => {
        if (!this.isConnected) return;
        const slide = this.slideshow.querySelector('slideshow-slide[aria-hidden="false"]');
        if (slide) this.updateSelection(slide.querySelector('[data-media-id]')?.dataset.mediaId);
      });
    }
    updateSelection(id) {
      const showingExamples = this.gallery?.classList.contains('fp-px-show-examples');
      this.querySelectorAll('button[data-pillow-media]').forEach(button => {
        button.setAttribute('aria-pressed', String(!showingExamples && button.dataset.pillowMedia === String(id)));
      });
    }
    disconnectedCallback() { this.controller?.abort(); }
  }
  customElements.define('fiorpaw-pillow-views', FiorpawPillowViews);
}
